import { render, staticRenderFns } from "./MerchantDetail.vue?vue&type=template&id=0da986ba&scoped=true&"
import script from "./MerchantDetail.vue?vue&type=script&lang=js&"
export * from "./MerchantDetail.vue?vue&type=script&lang=js&"
import style0 from "./MerchantDetail.vue?vue&type=style&index=0&id=0da986ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da986ba",
  null
  
)

export default component.exports